"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaveGroup = exports.joinGroup = exports.liteGroupMember = exports.liteGroup = void 0;
var app_1 = require("firebase/app");
var Profile_1 = require("./Profile");
var lodash_1 = require("lodash");
var GroupLog_1 = require("./GroupLog");
var liteGroup = function (group) {
    return (0, lodash_1.pick)(group, [
        "name",
        "descriptionHtml",
        "slug",
        "isStaffLed",
        "isUserLed",
        "isCategoryBased",
        "photoUrl",
        "subCategory",
        "id",
        "ref",
        "interestedSubCategoryIds",
        "interestedSubCategories",
    ]);
};
exports.liteGroup = liteGroup;
var liteGroupMember = function (gm) {
    return (0, lodash_1.pick)(gm, ["id", "profile", "interestLevel", "ref"]);
};
exports.liteGroupMember = liteGroupMember;
/**
 * NOTE: if caller provides `providedBatch` it is up to the caller to commit
 * that batch
 */
var joinGroup = function (network, group, profile, interestLevels, providedBatch) { return __awaiter(void 0, void 0, void 0, function () {
    var firestore, batch, interests, interestLevelId_1, interestLevel, groupMember, groupLog, doc;
    var _a, _b;
    var _c;
    return __generator(this, function (_d) {
        try {
            firestore = network.ref.firestore;
            batch = providedBatch || firestore.batch();
            // 1. update the user's current network membership
            // (do this first since the
            // frontend uses this to determine group membership and we want to reflect the
            // change as quickly as possible)
            batch.set(profile.ref, {
                currentNetworkMembership: {
                    groupMemberships: (_a = {},
                        _a[group.id] = (0, exports.liteGroup)(group),
                        _a),
                },
            }, { merge: true });
            interests = "interests" in profile ? profile.interests : undefined;
            interestLevelId_1 = (_c = Object.entries(interests || {}).find(function (_a) {
                var groupOrSubCatId = _a[0];
                return groupOrSubCatId === group.id;
            })) === null || _c === void 0 ? void 0 : _c[1];
            interestLevel = interestLevels === null || interestLevels === void 0 ? void 0 : interestLevels.find(function (il) { return il.id === interestLevelId_1; });
            groupMember = (0, lodash_1.merge)({
                profile: (0, Profile_1.liteProfile)(profile),
                profileRef: profile.ref,
                network: network,
                group: group,
            }, interestLevel ? { interestLevel: interestLevel } : {});
            batch.set(group.ref.collection("groupMembers").doc(profile.id), groupMember, {
                merge: true,
            });
            // 3. update the networkMembership for the user to store a copy of the
            // LiteGroup
            batch.set(network.ref.collection("members").doc(profile.id), {
                groupMemberships: (_b = {},
                    _b[group.id] = (0, exports.liteGroup)(group),
                    _b),
            }, { merge: true });
            groupLog = {
                kind: GroupLog_1.GroupLogKinds.Joined,
                group: (0, exports.liteGroup)(group),
                date: new Date(),
                body: "".concat(profile.name, " joined the group"),
                profile: (0, Profile_1.liteProfile)(profile),
            };
            doc = group.ref.collection("groupLogs").doc();
            batch.set(doc, groupLog);
            return [2 /*return*/, providedBatch ? Promise.resolve() : batch.commit()];
        }
        catch (e) {
            console.error("error in joinGroup", e, { network: network, group: group, profile: profile });
            throw e;
        }
        return [2 /*return*/];
    });
}); };
exports.joinGroup = joinGroup;
var leaveGroup = function (network, group, profile) { return __awaiter(void 0, void 0, void 0, function () {
    var firestore, batch;
    var _a, _b;
    return __generator(this, function (_c) {
        firestore = network.ref.firestore;
        batch = firestore.batch();
        // 1. update the user's current network membership (do this first since the
        // frontend uses this to determine group membership and we want to reflect the
        // change as quickly as possible)
        batch.update(profile.ref, (_a = {},
            _a["currentNetworkMembership.groupMemberships.".concat(group.id)] = app_1.default.firestore.FieldValue.delete(),
            _a));
        // 2. delete the groupMember - a background fn will sync the group members to
        // the `members` attribute of the group.
        // NOTE: that delay means that the user will still be listed as a member of
        // the group in the frontend until the bg sync runs. Might need some
        // optimistic updates strategy, or just rely on the user's group memberships
        // in their profile to determine if they're a member of a group, which is
        // updated synchronously.
        batch.delete(group.ref.collection("groupMembers").doc(profile.id));
        // 3. update the networkMembership for the user to store a copy of the
        // LiteGroup
        batch.update(network.ref.collection("members").doc(profile.id), (_b = {},
            _b["groupMemberships.".concat(group.id)] = app_1.default.firestore.FieldValue.delete(),
            _b));
        return [2 /*return*/, batch.commit()];
    });
}); };
exports.leaveGroup = leaveGroup;
//# sourceMappingURL=Group.js.map